import React from "react";
import "./SignalDetailCard.css";
import { AvatarImage } from "assets/SVGs/SVGs";
import { titles } from "constants/titles";
import { ROUTES_CONSTANTS } from "routes/route-constants";
import { convertDateFormate } from "utility";
import { useHistory } from "react-router-dom";

const SignalDetailCard = ({ className, signalData, onCardClick }) => {
  const history = useHistory();
  return (
    <div
      className={`${className} sdc_container`}
      onClick={() => onCardClick(signalData)}
    >
      <div className="sdc_img_container">
        {signalData?.image_url ? (
          <img
            src={signalData?.image_url}
            alt="Device"
            className="sdc_device_image"
          />
        ) : (
          <AvatarImage height="50" width="50" />
        )}
      </div>
      <div className="sdc_right_container">
        <p className="sdc_device_name">{signalData?.device_name}</p>
        <p className="sdc_device_name mb5">{signalData?.signal}</p>
        <p className="sdc_timestamp">{convertDateFormate(signalData?.date)}</p>
        {signalData?.latitude && (
          <p
            className="sdc_see_map"
            onClick={(e) => {
              e.stopPropagation();
              history.push(ROUTES_CONSTANTS.caregiverTracking, {
                isFromSignalHistory: true,
                item: signalData,
              });
            }}
          >
            {titles?.see_map}
          </p>
        )}
      </div>
    </div>
  );
};

export default SignalDetailCard;
